// RefreshButton.js
var RefreshButton = pc.createScript('refreshButton');


var refreshAnim;

RefreshButton.prototype.initialize = function() {

    refreshAnim = this.entity
            .tween(this.entity.getLocalEulerAngles())
            .rotate(new pc.Vec3(0, 0, -180), 0.2, pc.Linear)
            .yoyo(true)
            .repeat(2);
};


